import React, { Component } from 'react';
import cs from 'classnames';
import upperFirst from 'lodash/upperFirst';
import isEmpty from 'lodash/isEmpty';

import { track } from '~/misc/metrics';
import { getUrlQeury } from '~/misc/formatUrlquery';
import { options } from '~/pages/Payment/utils';

import css from './style.css';

export default class PaymentOptions extends Component {
  constructor(props) {
    super(props);
    const group = this.props.default && this.props.default.planId.split('.');
    this.state = {
      selectedBill: this.props.default,
      nowExpanded: -1,
      selectedGroup: upperFirst(group[0]) || 'Essential',
      planName: 'Annual',
      showOptions: options.slice(0, 4),
      showMore: false,
    };

    this.renderPriceCard = this.renderPriceCard.bind(this);
  }
  componentDidMount() {}
  selectPlan(item) {
    if (item.disable) return;
    const planData = item.planId.split('.');
    const selectedGroup = upperFirst(planData[0]);
    const planName = upperFirst(planData[1]);
    this.setState({ selectedBill: item, selectedGroup, planName });
    this.props.changeSelected(item);
  }
  setShowMore() {
    if (!this.optionsContainer) return;
    const query = getUrlQeury();
    if (!isEmpty(query) && query.from) {
      track('pruchase_show_more', { source: query.from });
    }
    const newStatus = !this.state.showMore;
    // this.optionsContainer.style.height = newStatus ? "auto" : "150px";
    this.setState({
      showMore: newStatus,
      showOptions: newStatus ? options : options.slice(0.4),
    });
  }
  renderPriceCard(item) {
    const { selectedBill } = this.state;
    if (!item || Object.keys(item).length === 0) {
      return <div className={css.emptyPriceCard}></div>;
    }
    return (
      <div
        className={cs(css.priceCard, {
          [css.priceCardSelected]: item.planId === selectedBill.planId,
          [css.priceCardDisable]: item.disable,
          [css.priceCardSimple]: !item.discountText,
        })}
        onClick={() => this.selectPlan(item)}>
        <div className={css.priceCardShow}>${item.shwoDiscountPrice}</div>
        <div className={css.pricsPlan}>{item.planText}</div>
        {item.discountText && <div className={css.discountText}>{item.discountText}</div>}
        {item.planId === selectedBill.planId && <div className={css.selectedLogo}></div>}
        {item.disable && <div className={css.priceCardMask}></div>}
      </div>
    );
  }
  expandDetail(index) {
    const { nowExpanded } = this.state;
    const newExpanded = index === nowExpanded ? -1 : index;
    this.setState({ nowExpanded: newExpanded });
  }
  render() {
    const { nowExpanded, selectedGroup, planName, selectedBill, showMore, showOptions } =
      this.state;
    const { bills = [] } = this.props;
    return (
      <section className={css.paymentOptions}>
        <header>
          <span>Selected Package: </span>
          <span>
            {selectedGroup} ( {planName} Pricing ${selectedBill.shwoDiscountPrice} )
          </span>
        </header>
        <main>
          <div className={css.paymentOptionsTable}>
            <div className={cs(css.row, css.stickyRow)}>
              <div className={css.titleColumn}></div>
              <div className={css.billOptions}>
                {bills.map(item => {
                  // bills order essential preferred ultimate
                  return (
                    <div className={css.billPackage} key={item.title}>
                      <header>
                        <div className={css.saleProm}>
                          {item.salesPromotion ? (
                            <span>{item.salesPromotion}</span>
                          ) : (
                            <span className={css.salePromEmpty}></span>
                          )}
                        </div>
                        <div className={css.billPackageTitle}>{item.title}</div>
                        <div className={css.billPackageFeatures}>{item.featuresText}</div>
                      </header>
                      <main>
                        <div className={css.annual}>{this.renderPriceCard(item.annually)}</div>
                        <div className={css.monthly}>{this.renderPriceCard(item.monthly)}</div>
                      </main>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className={css.optionsContainer} ref={node => (this.optionsContainer = node)}>
              {showOptions.map((item, index) => {
                return (
                  <div className={css.row} key={index}>
                    <div className={css.titleColumn}>
                      <div className={css.showContent}>
                        <span>{item.name}</span>
                        <img
                          onClick={() => this.expandDetail(index)}
                          src='/assets/exclamation-cricle.png'
                        />
                      </div>
                      {index === nowExpanded && (
                        <div className={css.hideContent}>{item.expandContent}</div>
                      )}
                    </div>
                    <div className={css.selectColumn}>
                      {item.essential && (
                        <img className={css.rightSymbol} src='/assets/rightGreen.svg' />
                      )}
                    </div>
                    <div className={css.selectColumn}>
                      {item.preferred && (
                        <img className={css.rightSymbol} src='/assets/rightGreen.svg' />
                      )}
                    </div>
                    <div className={css.selectColumn}>
                      {item.ultimate && (
                        <img className={css.rightSymbol} src='/assets/rightGreen.svg' />
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            {!showMore && (
              <div className={css.showMoreBtn} onClick={() => this.setShowMore()}>
                <span>View More</span>
                <img src='/assets/ic-more.svg' />
              </div>
            )}
          </div>
        </main>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Payment/components/PaymentOptions/index.js